import { useState, useEffect } from 'react';
import { FileText, HelpCircle } from 'lucide-react';
import { useSiteConfig } from '../../hooks/useSiteConfig';
import { SiteFiling } from '../../components/common/SiteFiling';

// 服务条款内容
const termsContent = [
  {
    id: 1,
    title: '服务说明',
    content: `1.1 活动精英订单预约管理系统（订单预约管理平台，以下简称"本平台"）由郑州捕风捉影文化传播有限公司（以下简称"运营方"）开发与运营，面向活动执行者、自由职业人员及中小企业，提供订单管理、预约调度、客户关系管理、对账核算等在线服务。

1.2 使用本平台前，请务必仔细阅读本服务条款。一旦您注册账户或使用本平台的任何功能，即表示您已阅读、理解并同意受本条款约束。`
  },
  {
    id: 2,
    title: '平台性质与责任边界',
    content: `2.1 本平台仅提供订单预约与对账核算的在线管理工具，不参与订单交易、结算等环节，不代收代付、不提供担保，也不介入交易撮合。所有订单内容均由交易双方自行填写、自行提交，平台仅据实记录与核算。

2.2 用户与客户双方因订单、结算等问题产生的纠纷与本平台无关，需自行协商解决；平台不参与调解，也不对纠纷的过程与结果承担责任。

2.3 重要订单数据请务必自行以多种方式备份处理（例如在"设置 → 数据与隐私"导出备份、线下另行留档），以防意外丢失。

2.4 免费版用户因数据破坏、删除或其他任何原因产生的损失，本平台不承担协商与赔付义务。`
  },
  {
    id: 3,
    title: '账户注册与实名认证',
    content: `3.1 用户需提供真实、准确的个人或企业信息进行注册。

3.2 账户密码由用户自行设置并妥善保管，因密码泄露导致的损失由用户自行承担。

3.3 用户应及时更新账户信息，确保其准确性；如发现账户异常，应立即联系客服。

3.4 为何需要实名认证：本平台内的订单基于真实的用户／客户身份而存在，错误的身份将导致错误的订单归属与核算导向，故平台要求对身份进行认证。

3.5 身份唯一原则：平台要求"用户即客户""系统内身份唯一"，避免一人多重身份。已认证的身份高于系统内未认证的身份，平台将对重复身份执行合并——未认证的用户／客户身份须向已认证的对应身份合并或清理。

3.6 认证信息处理声明：身份验证仅在注册环节进行；验证后的身份信息在系统内加密存储，不会被其他用户调用；用户注销时，关键身份信息随注销一并删除。`
  },
  {
    id: 4,
    title: '账号注销与数据删除',
    content: `4.1 您可在"个人中心 → 账号安全"或"设置"中申请注销账号。

4.2 注销后，本平台将清除该账号的关键个人信息（含用于登录的凭据、实名认证信息等），并停止对该账号提供服务。

4.3 出于对账与留痕的需要，已提交且与交易对方（客户／对端用户）相关联的订单数据，本平台按隐私政策及法定留存要求处理，不因单方注销而对交易对方不可见。

4.4 注销不可撤销。请在注销前自行导出并备份所需数据，注销后平台不再承担恢复义务。`
  },
  {
    id: 5,
    title: '服务内容与限制',
    content: `5.1 本平台提供订单管理、预约调度、客户管理、对账核算、数据分析等服务。

5.2 用户应合理使用平台服务，不得从事违法违规活动，不得利用平台侵害他人合法权益。

5.3 本平台有权根据业务需要调整服务内容和功能，并以平台公告等形式告知。

5.4 免费版用户可能受到功能限制，具体以平台公告及会员说明为准。`
  },
  {
    id: 6,
    title: '数据归属与隐私',
    content: `6.1 用户在平台上存储的业务数据归用户所有，本平台有权按照隐私政策在服务所需范围内使用相关数据。

6.2 跨用户可见性：本平台以"订单"连接交易双方。您创建的订单，其约定的对方（客户／交易对象）在与该订单相关的范围内可见相应内容（如订单信息、金额、状态与审核记录），以便双方对账核对；这是平台正常功能所必需，不构成越权使用。

6.3 本平台将采取合理措施保护用户数据安全，但不保证绝对安全。

6.4 用户应遵守数据保护相关法律法规，不得上传违法或侵权内容。

6.5 详细隐私保护政策请参阅《隐私政策》。`
  },
  {
    id: 7,
    title: '收费与退款',
    content: `7.1 本平台提供免费和付费（尊享会员）服务，付费服务价格以平台公布为准。

7.2 会员费通过第三方持牌支付机构（如支付宝、微信支付）收取，本平台不自行归集或保管用户资金。

7.3 用户购买付费服务后，除非服务存在严重质量问题，否则不支持退款。

7.4 如因平台原因导致服务无法正常使用，用户可申请退款。

7.5 付费服务到期后，如用户未及时续费，平台有权停止相应的付费功能。`
  },
  {
    id: 8,
    title: '知识产权',
    content: `8.1 本平台的所有内容、功能和技术均受知识产权保护。

8.2 用户不得复制、修改、分发平台内容，不得进行反向工程。

8.3 用户上传的内容如涉及侵权，应承担相应法律责任。

8.4 平台有权在必要时移除侵权内容。`
  },
  {
    id: 9,
    title: '免责声明与责任限制',
    content: `9.1 本平台按"现状"提供服务，不对服务的连续性、准确性、完整性作出明示或暗示的担保。

9.2 在法律允许的最大范围内，本平台对因使用或无法使用服务导致的间接损失、利润损失不承担责任。

9.3 本平台对第三方链接或集成服务不负责，任何第三方服务产生的风险由用户自行承担。

9.4 如因不可抗力（自然灾害、政府行为、网络基础设施故障等）导致服务中断，本平台不承担违约责任，但将尽力在最短时间内恢复服务。`
  },
  {
    id: 10,
    title: '争议解决',
    content: `10.1 适用法律：本条款受中华人民共和国法律管辖。

10.2 协商解决：如发生争议，双方应首先通过友好协商解决。

10.3 诉讼：协商不成的，任何一方均可向运营方（郑州捕风捉影文化传播有限公司）注册地有管辖权的人民法院提起诉讼。

10.4 条款独立性：本条款任何条款被认定为无效，不影响其他条款的效力。`
  }
];

export default function TermsPage() {
  const { siteName, logoUrl } = useSiteConfig();
  const [isScrolled, setIsScrolled] = useState(false);

  // 监听滚动事件，控制导航栏样式
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      {/* 顶部导航 */}
      <nav className={`fixed top-0 left-0 right-0 z-50 h-[70px] transition-all duration-500 ${isScrolled ? 'bg-white/95 backdrop-blur-md border-b border-slate-100' : 'bg-transparent'}`}>
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 h-full flex items-center justify-between">
          <a href="/login" className="flex items-center gap-3">
            <img 
              src={logoUrl} 
              alt="Logo" 
              className="w-10 h-10"
            />
            <span className={`text-lg font-bold tracking-wide transition-colors ${isScrolled ? 'text-slate-800' : 'text-white'}`}>
              {siteName}
            </span>
          </a>
          <div className="flex items-center gap-6">
            <a href="/help" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-slate-600 hover:opacity-70' : 'text-white/90 hover:text-white'}`}>
              帮助中心
            </a>
            <a href="/about" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-slate-600 hover:opacity-70' : 'text-white/90 hover:text-white'}`}>
              关于我们
            </a>
            <a href="/contact" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-slate-600 hover:opacity-70' : 'text-white/90 hover:text-white'}`}>
              联系我们
            </a>
            <a 
              href="/login" 
              className={`text-sm font-medium px-5 py-2 rounded-full transition-all ${isScrolled ? 'bg-teal-600 text-white hover:bg-teal-700' : 'border border-white/70 text-white hover:bg-white/20'}`}
            >
              立即登录
            </a>
          </div>
        </div>
      </nav>

      {/* Hero 顶部区域 */}
      <section className="pt-[140px] pb-16 bg-gradient-to-br from-slate-800 via-slate-700 to-teal-800">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 text-center">
          {/* 标签徽章 */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-teal-500/20 border border-teal-400/30 mb-6">
            <FileText className="h-4 w-4 text-teal-300" />
            <span className="text-xs font-medium text-teal-300">法律文件</span>
          </div>

          {/* 标题 */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            服务条款
          </h1>

          {/* 描述文字 */}
          <p className="max-w-xl mx-auto text-sm md:text-base text-slate-300 leading-relaxed">
            请在使用本平台前仔细阅读以下条款，使用即代表您已同意本协议。
          </p>
        </div>
      </section>

      {/* 主内容区 */}
      <main className="flex-1 py-14">
        <div className="max-w-md md:max-w-2xl mx-auto px-6">
          {/* 面包屑导航 */}
          <div className="text-xs text-slate-500 mb-8">
            <a href="/" className="hover:text-teal-600 transition-colors">首页</a>
            <span className="mx-2">/</span>
            <span className="text-slate-700 font-semibold">服务条款</span>
          </div>

          {/* 目录卡片 */}
          <div className="bg-white rounded-xl border border-slate-100 p-6 mb-10">
            <h2 className="text-sm font-semibold text-slate-500 tracking-wider uppercase mb-4">
              目录
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              {termsContent.map((item) => (
                <a 
                  key={item.id}
                  href={`#section-${item.id}`}
                  className="flex items-center gap-2 text-sm text-slate-600 hover:text-teal-600 transition-colors py-1"
                >
                  <span className="w-5 h-5 bg-teal-50 text-teal-600 rounded text-xs flex items-center justify-center">
                    {item.id}
                  </span>
                  {item.title}
                </a>
              ))}
            </div>
          </div>

          {/* 条款内容卡片 */}
          {termsContent.map((item) => (
            <div key={item.id} id={`section-${item.id}`} className="bg-white rounded-xl border border-slate-100 p-7 mb-8">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-7 h-7 bg-teal-500 text-white rounded-lg text-xs font-bold flex items-center justify-center">
                  {item.id}
                </span>
                <h3 className="text-base font-bold text-slate-800">
                  {item.title}
                </h3>
              </div>
              <p className="text-sm text-slate-600 leading-relaxed whitespace-pre-line">
                {item.content}
              </p>
            </div>
          ))}

          {/* 底部提示卡片 */}
          <div className="bg-teal-50 border border-teal-100 rounded-xl p-6 text-center mt-10">
            <HelpCircle className="h-5 w-5 text-teal-500 mx-auto mb-2 block" />
            <p className="text-sm text-teal-700 leading-relaxed">
              如您对本服务条款有任何疑问，欢迎
              <a href="/contact" className="font-medium underline hover:text-teal-900 cursor-pointer mx-1">
                联系我们
              </a>
              ，我们将在 7 个工作日内回复。
            </p>
          </div>
        </div>
      </main>

      {/* 底部导航 */}
      <footer className="bg-slate-800 text-white py-8">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            {/* 左侧：Logo和品牌信息 */}
            <div className="flex items-center gap-3">
              <img 
                src={logoUrl} 
                alt="Logo" 
                className="h-8 w-auto"
              />
              <div>
                <div className="font-semibold text-lg">{siteName}</div>
                <div className="text-xs text-slate-400">让每一笔业务都有据可查</div>
              </div>
            </div>

            {/* 右侧：导航链接 */}
            <div className="flex flex-wrap gap-6 text-sm text-slate-400">
              <a href="/terms" className="hover:text-white transition-colors">服务条款</a>
              <a href="/privacy" className="hover:text-white transition-colors">隐私政策</a>
              <a href="/help" className="hover:text-white transition-colors">帮助中心</a>
              <a href="/contact" className="hover:text-white transition-colors">联系我们</a>
              <a href="/about" className="hover:text-white transition-colors">关于我们</a>
            </div>
          </div>

          {/* 底部备案信息 */}
          <div className="border-t border-slate-700 mt-8 pt-6 text-center text-xs text-slate-500">
            <SiteFiling />
          </div>
        </div>
      </footer>
    </div>
  );
}
